module.exports = __webpack_public_path__ + "static/media/IMG_20180530_120424.ca458bda.jpg";